import { render, staticRenderFns } from "./ListStatus.vue?vue&type=template&id=71bd7a34"
import script from "./ListStatus.vue?vue&type=script&lang=ts"
export * from "./ListStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports